// extracted by mini-css-extract-plugin
export default {"note":"Notes_note__JwabE","content":"Notes_content__6o8LW"};